var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-autocomplete',_vm._b({attrs:{"value":_vm.value,"disabled":_vm.items.length < 1,"items":_vm.items,"label":"Semester","item-text":"shortText","item-value":"id","return-object":""},on:{"change":_vm.select}},'v-autocomplete',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }